import ReactDOM from 'react-dom/client';
import App from './App';
import '@excalidraw/excalidraw/index.css';

import * as Sentry from '@sentry/react';
import { setupGlobalErrorHandler } from './utils/globalErrorHandler';

if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [],
  });
}

export const setSentryUser = (username: string, email: string) => {
  Sentry.setUser({
    username,
    email,
  });
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

setupGlobalErrorHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
